import {
  faCheck,
  faClipboardCheck,
  faPaperPlaneTop,
  faEye,
  faHandshake,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons'
import { StatusListingColors } from '@labrav/react-components'
import { StatusItem } from '@labrav/react-components/lib/@types/v2/components/StatusListing'
import { isEmpty } from 'lodash'

import {
  OfferStageStatus,
  OfferStatus,
  type StatusOfferResObj,
} from '../modules/privateOffer/reducer'

export const getStatusOfferData = (
  auditJson: StatusOfferResObj,
  currentStatus: string
): StatusItem[] => {
  return Object.entries(auditJson).map(([status, completed]) => {
    let icon
    let color
    let background
    let display = true
    let sortOrder = 0
    let tooltipText = ''
    switch (status) {
      case OfferStageStatus.OFFER_CREATION_IN_PROGRESS:
        icon = faCheck
        color = StatusListingColors.WHITE
        background = StatusListingColors.COMPLETED
        sortOrder = 1
        tooltipText =
          'Your offer was created on this date and time at Labra. Please check the status for further updates.'
        break
      case OfferStageStatus.OFFER_EMAIL_SENT:
        icon =
          isEmpty(completed) &&
          currentStatus === OfferStatus.PRIVATE_OFFER_FAILED
            ? faXmark
            : faPaperPlaneTop
        background =
          isEmpty(completed) &&
          currentStatus === OfferStatus.PRIVATE_OFFER_FAILED
            ? StatusListingColors.REJECTED
            : StatusListingColors.LIMITED
        color =
          isEmpty(completed) &&
          currentStatus === OfferStatus.PRIVATE_OFFER_FAILED
            ? StatusListingColors.WHITE
            : StatusListingColors.GREY
        sortOrder = 2
        tooltipText =
          isEmpty(completed) &&
          currentStatus === OfferStatus.PRIVATE_OFFER_FAILED
            ? 'Your offer creation failed at Cloud provider'
            : 'Your offer was created on cloud marketplcae and emailed to recipients on this date and time.'
        break

      case OfferStageStatus.OFFER_VIEWED:
        icon = faEye
        sortOrder = 3
        tooltipText = 'Your offer was viewed by buyer on this date and time.'

        break
      case OfferStageStatus.OFFER_ACCEPTED:
        icon = faHandshake
        sortOrder = 4
        tooltipText = 'Your offer was accepted by buyer on this date and time.'
        break
      default:
        icon = faClipboardCheck
        display = false
    }

    return {
      status,
      completed,
      icon,
      color: color || '',
      background: background || '',
      display,
      sortOrder,
      tooltipText,
    }
  })
}
